import React from 'react'
import cn from 'classnames'
import { Container } from '@kogk/common'

export type RowType = { left: string; right: string }

const Table: React.FC<{
  title: string
  rows: RowType[]
}> = ({ title, rows }) => {
  return (
    <Container className='page-slice-spacer__smaller--top-of-page d-flex justify-content-center'>
      <div className='table-container w-100'>
        <h4 className='mb-2'>{title}</h4>
        {rows.map((row, index) => (
          <div
            key={`${title}-row-${index}`}
            className={cn('d-flex justify-content-between table-container__element', {
              'table-container__element--thick': !row.left
            })}
          >
            <span>{row.left}</span>
            <span>{row.right}</span>
          </div>
        ))}
      </div>
    </Container>
  )
}

export default Table
